import './ImportSummaryPane.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { ColumnLayout } from '../../../../../../../../common/layouts/columnLayout/ColumnLayout';
import { IImportAnnotationRejection, importAnnotationsRejectionReasonTranslation } from '../../../../models/ImportAnnotationsReport';

library.add(faCaretUp, faCaretDown);

interface IProps {
  importedItemsCount: number;
  skippedItemsCount: number;
  rejectedAnnotations: IImportAnnotationRejection[];
}

export const ImportSummaryPane = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { importedItemsCount, rejectedAnnotations, skippedItemsCount } = props;
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const toggle = (): void => {
    setIsOpened(!isOpened);
  };

  const rejectionReasons = rejectedAnnotations.map((a) => `${a.datasetName} - ${a.imageName} - ${t(importAnnotationsRejectionReasonTranslation(a.reason))}`);

  return (
    <ColumnLayout
      size='sm'
      className='import-summary-pane'
    >
      <div>
        {importedItemsCount} {t(`new.projects.details.import_annotations.steps.summary.annotation_imported`, { count: importedItemsCount })}
        {importedItemsCount > 0 && <span className='success-text'> {t('new.projects.details.import_annotations.steps.summary.successfully')}</span>}
      </div>
      {props.skippedItemsCount > 0 && (
        <div
          className='collapsible'
          onClick={toggle}
        >
          {skippedItemsCount} {t(`new.projects.details.import_annotations.steps.summary.annotation`, { count: skippedItemsCount })}
          <span className='error-text'> {t('new.projects.details.import_annotations.steps.summary.skipped')} </span>
          <FontAwesomeIcon icon={isOpened ? faCaretUp : faCaretDown} />
        </div>
      )}
      {isOpened && (
        <div className='skipped-items-pane'>
          {rejectionReasons.map((_, index) => (
            <div
              className='skipped-item'
              key={index}
            >
              {rejectionReasons[index]}
            </div>
          ))}
        </div>
      )}
    </ColumnLayout>
  );
});
